exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui-check_label {\n  padding: 5px !important;\n}\n.weui-cells_checkbox {\n  font-size: 5px !important;\n}\n.weui-cells:after {\n  display: none;\n}\n.weui-cells:before {\n  display: none;\n}\n.weui-cell:before {\n  display: none;\n}\n.weui-cells__title {\n  font-size: 0.4rem !important;\n  color: #191919 !important;\n}\n.weui-cells_checkbox > label > * {\n  font-size: 0.32rem;\n}\n", ""]);

// exports
